/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import styles from '../styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  checkedPairs: PropTypes.array.isRequired,
  onDelSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

class DeleteModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      checkedPairs: props.checkedPairs,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.pairs.delete');
    this.onSubmite = this.onSubmite.bind(this);
  }

  componentWillReceiveProps({ show, checkedPairs }) {
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (!_.isEqual(checkedPairs, this.props.checkedPairs)) {
      this.setState({ checkedPairs });
    }
  }

  onSubmite() {
    this.setState({ submitStatus: 'pending' });

    const { checkedPairs } = this.state;
    const delFunc = () => {
      const pair = checkedPairs.pop();
      if (pair) {
        callAPI({
          endpoint: `/tdmng/pairs/${pair}`,
          method: 'DELETE',
        }).then(() => {
          delFunc();
        }).catch(() => {});
      } else {
        this.setState({ submitStatus: '' });

        _.delay(() => {
          this.props.onDelSuccess();
          this.props.onCancel();
        }, 250);
      }
    };
    delFunc();
  }

  render() {
    const { show, submitStatus } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-danger"
        backdrop="static"
        show={show}
        onHide={this.props.onCancel}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('title')}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">{this.intlMsg.msg('warn')}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-default"
            className={styles.white}
            onClick={this.props.onCancel}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-danger"
            onClick={this.onSubmite}
            disabled={submitStatus === 'pending'}
          >
            {submitStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DeleteModal.propTypes = propTypes;

export default injectIntl(DeleteModal);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Pairs/DeleteModal.jsx